export var ICON_ACTIVE_COLORS = {
  heart: '#e03d43'
};